// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"2":"d8535ad5","12":"ee1c1357","27":"ba5b193f","231":"3aac4c25","247":"15ae8001","289":"5ffcb864","398":"7db867ab","451":"5a71e28f","453":"46eaa295","516":"3b2cb878","777":"e0a07ad2","821":"c86698b5","855":"431aa920"}[chunkId] + ".chunk.js";
};